import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

const sparkData = [6,2,8,4,3,8,1,3,6,5,9,2,8,1,4,8,9,8,2,1];

const SparkChart = ({ color }) => {

  const options = {
    chart: {
      type: "area",
      sparkline: { enabled: true },
      toolbar: { show: false }
    },

    stroke: {
      curve: "smooth",
      width: 2
    },

    fill: {
      type: "solid",
      opacity: 1
    },

    colors: [color],

    tooltip: { enabled: false },

    grid: {
      show: false,
      padding: {
        top: -10,
        bottom: -10,
        left: 0,
        right: 0
      }
    },

    xaxis: {
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },

    yaxis: { show: false }
  };

  const series = [{ data: sparkData }];

  return (
    <div style={{ width: "120px", overflow: "hidden" }}>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={55}
        width={120}
      />
    </div>
  );
};

const SubscriptionStats = () => {
  return (
    <>
      <style>
        {`

        .stats-card{
          border:1px solid #e6e6e6;
          border-radius:6px;
          box-shadow:none;
        }

        .stats-title{
          font-size:14px;
          color:#6c757d;
          margin-bottom:4px;
          display:block;
        }

        .stats-value{
          font-size:20px;
          font-weight:600;
          color:#0f172a;
        }

        .border-divider{
          border-bottom:1px solid #e6e6e6;
          padding-bottom:14px;
          margin-bottom:12px;
        }

        .growth{
          font-size:12px;
          color:#ff4d4f;
          display:flex;
          align-items:center;
          font-weight:500;
        }

        .week{
          font-size:12px;
          color:#6c757d;
          margin-left:4px;
        }

        .chart-box{
          overflow:hidden;
          display:flex;
          justify-content:flex-end;
        }

        @media(max-width:768px){
          .stats-value{
            font-size:18px;
          }
        }

        `}
      </style>

      <Row className="mt-1">

        {/* Card 1 */}
 <Row>
  {/* Card 1 */}
  <Col xl={3} md={6} sm={12} className="d-flex mt-3 mt-md-0">
    <Card className="flex-fill stats-card h-100">
      <Card.Body>

        <div className="border-divider pb-2 mb-2">
          <Row className="align-items-center">
            
            <Col xs={7}>
              <span className="stats-title">Total Transaction</span>
              <h5 className="stats-value">$5,340</h5>
            </Col>

            <Col xs={5} className="chart-box text-end">
              <SparkChart color="#f59e0b"/>
            </Col>

          </Row>
        </div>

        <div className="d-flex align-items-center flex-wrap">
          <span className="growth me-2">
            <i className="ti ti-arrow-wave-right-up me-1"></i>
            +19.01%
          </span>
          <span className="week">from last week</span>
        </div>

      </Card.Body>
    </Card>
  </Col>

  {/* Card 2 */}
  <Col xl={3} md={6} sm={12} className="d-flex mt-3 mt-md-0">
    <Card className="flex-fill stats-card h-100">
      <Card.Body>

        <div className="border-divider pb-2 mb-2">
          <Row className="align-items-center">
            
            <Col xs={7}>
              <span className="stats-title">Total Subscribers</span>
              <h5 className="stats-value">600</h5>
            </Col>

            <Col xs={5} className="chart-box text-end">
              <SparkChart color="#3b82f6"/>
            </Col>

          </Row>
        </div>

        <div className="d-flex align-items-center flex-wrap">
          <span className="growth me-2">
            <i className="ti ti-arrow-wave-right-up me-1"></i>
            +19.01%
          </span>
          <span className="week">from last week</span>
        </div>

      </Card.Body>
    </Card>
  </Col>

  {/* Card 3 */}
  <Col xl={3} md={6} sm={12} className="d-flex mt-3 mt-md-0">
    <Card className="flex-fill stats-card h-100">
      <Card.Body>

        <div className="border-divider pb-2 mb-2">
          <Row className="align-items-center">
            
            <Col xs={7}>
              <span className="stats-title">Active Subscribers</span>
              <h5 className="stats-value">560</h5>
            </Col>

            <Col xs={5} className="chart-box text-end">
              <SparkChart color="#22c55e"/>
            </Col>

          </Row>
        </div>

        <div className="d-flex align-items-center flex-wrap">
          <span className="growth me-2">
            <i className="ti ti-arrow-wave-right-up me-1"></i>
            +19.01%
          </span>
          <span className="week">from last week</span>
        </div>

      </Card.Body>
    </Card>
  </Col>

  {/* Card 4 */}
  <Col xl={3} md={6} sm={12} className="d-flex mt-3 mt-md-0">
    <Card className="flex-fill stats-card h-100">
      <Card.Body>

        <div className="border-divider pb-2 mb-2">
          <Row className="align-items-center">
            
            <Col xs={7}>
              <span className="stats-title">Expired Subscribers</span>
              <h5 className="stats-value">40</h5>
            </Col>

            <Col xs={5} className="chart-box text-end">
              <SparkChart color="#ef4444"/>
            </Col>

          </Row>
        </div>

        <div className="d-flex align-items-center flex-wrap">
          <span className="growth me-2">
            <i className="ti ti-arrow-wave-right-up me-1"></i>
            +19.01%
          </span>
          <span className="week">from last week</span>
        </div>

      </Card.Body>
    </Card>
  </Col>
</Row>
<style>
  {
    `.stats-card {
  border-radius: 6px;
}

@media (max-width: 576px) {
  .stats-title {
    font-size: 13px;
  }

  .stats-value {
    font-size: 16px;
  }

  .chart-box {
    display: flex;
    justify-content: flex-end;
  }
}
    `
  }
</style>
      </Row>
    </>
  );
};

export default SubscriptionStats;